<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            {{ title }}
        </div>

        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content speedometer" v-if="!noData">
            <svg ref="svgcontent"></svg>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer" v-if="!noData">
            <div class="legend" v-for="(d, i) in legends" :key="i">
                <span :style="{ 'background-color': cores[i] }"></span>
                {{ $t(d) }}
            </div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="chart-no-text" v-if="noData">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>
    </div>
</template>

<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,
    props: ['title', 'datacontent', 'smoothing'],
    data() {
        return {
            cores: [],
            total: 0,
            legends: [],
            noData: false,
        };
    },
    created() {
        this.legends = ['baixo', 'medio', 'alto'];
        this.cores = paleta.getSpeedometerColor();

        if (!this.datacontent) {
            this.noData = true;
        }
    },
    mounted() {
        this.mountChart();
    },
    methods: {
        mountChart() {
            var powerGauge = this.gauge(this.$refs.svgcontent, {
                size:
                    this.$refs.chartContent.offsetWidth > this.$refs.chartContent.offsetHeight
                        ? this.$refs.chartContent.offsetHeight
                        : this.$refs.chartContent.offsetWidth,
                clipWidth:
                    this.$refs.chartContent.offsetWidth > this.$refs.chartContent.offsetHeight
                        ? this.$refs.chartContent.offsetHeight
                        : this.$refs.chartContent.offsetWidth,
                clipHeight: 200,
                ringWidth: 60,
                maxValue: this.datacontent.total,
                transitionMs: 4000,
            });
            powerGauge.render();

            let updateReadings = () => {
                powerGauge.update(this.datacontent.partial);
            };

            updateReadings();
        },
        getPointer(pw) {
            let percent = this.datacontent.partial / this.datacontent.total;
            return percent * pw;
        },
        getLegendValues(i) {

            let from = Math.round(this.datacontent.total * (i / this.legends.length));
            let to = Math.round(this.datacontent.total * ((i + 1) / this.legends.length));

            return `${from} - ${to > 1 && i < this.legends.length - 1 ? to - 1 : to}`;
        },
        gauge(container, configuration) {
            var that = {};
            var config = {
                size: this.$refs.chartContent.offsetWidth,
                clipWidth: this.$refs.chartContent.offsetWidth,
                clipHeight: this.$refs.chartContent.offsetHeight,
                ringInset: 0,
                ringWidth: 20,

                pointerWidth: 5,
                pointerTailLength: 2,
                pointerHeadLengthPercent: 0.6,

                minValue: 0,
                maxValue: this.datacontent.total,

                minAngle: -120,
                maxAngle: 120,

                transitionMs: 750,

                majorTicks: 3,
                labelFormat: this.$d3.format('d'),
                labelInset: 10,

                arcColorFn: this.$d3.interpolateHsl(
                    this.$d3.rgb(paleta.chartColors[2]),
                    this.$d3.rgb(paleta.chartColors[0])
                ),
            };
            var range = undefined;
            var r = undefined;
            var pointerHeadLength = undefined;
            var value = 0;

            var svg = undefined;
            var arc = undefined;
            var scale = undefined;
            var ticks = undefined;
            var tickData = undefined;
            var pointer = undefined;

            let deg2rad = (deg) => {
                return (deg * Math.PI) / 180;
            };

            let newAngle = (d) => {
                var ratio = scale(d);
                var newAngle = config.minAngle + ratio * range;
                return newAngle;
            };

            let configure = (configuration) => {
                var prop = undefined;
                for (prop in configuration) {
                    config[prop] = configuration[prop];
                }

                range = config.maxAngle - config.minAngle;
                r = config.size / 2;
                pointerHeadLength = Math.round(r * config.pointerHeadLengthPercent);

                // a linear scale that maps domain values to a percent from 0..1
                scale = this.$d3
                    .scaleLinear()
                    .range([0, 1])
                    .domain([config.minValue, config.maxValue]);

                ticks = scale.ticks(config.majorTicks);
                tickData = this.$d3.range(config.majorTicks).map(function () {
                    return 1 / config.majorTicks;
                });

                arc = this.$d3
                    .arc()
                    .innerRadius(r - config.ringWidth / 2)
                    .outerRadius(r - config.ringInset)
                    .startAngle(function (d, i) {
                        var ratio = d * i;
                        return deg2rad(config.minAngle + ratio * range);
                    })
                    .endAngle(function (d, i) {
                        var ratio = d * (i + 1);
                        return deg2rad(config.minAngle + ratio * range);
                    });
            };
            that.configure = configure;

            let centerTranslation = () => {
                var width = this.$refs.chartContent.offsetWidth;
                var height = this.$refs.chartContent.offsetHeight;
                var margin = { top: -30, left: 0, bottom: 0, right: 0 };
                var chartWidth = width - (margin.left + margin.right);
                var chartHeight = height - (margin.top + margin.bottom);
                return `translate(${chartWidth / 2}, ${chartHeight / 2})`;
            };

            let isRendered = () => {
                return svg !== undefined;
            };
            that.isRendered = isRendered;

            let render = (newValue) => {
                svg = this.$d3
                    .select(container)
                    // .append("svg:svg")
                    .attr('class', 'gauge')
                    .attr('width', config.clipWidth)
                    .attr('height', config.clipHeight);

                var centerTx = centerTranslation();

                var arcs = svg.append('g').attr('class', 'arc').attr('transform', centerTx);

                var div = this.$d3
                    .select('body')
                    .append('div')
                    .attr('class', 'chart-tooltip')
                    .style('opacity', 0);

                let colors = this.cores;

                arcs.selectAll('path')
                    .data(tickData)
                    .enter()
                    .append('path')
                    .attr('fill', function (d, i) {
                        // return config.arcColorFn(d * i);
                        return colors[i];
                    })
                    .attr('d', arc)
                    .on('mouseover', (d, i) => {
                        div.transition().duration(200).style('opacity', 0.9).style('color', '#FFF');
                        //   .style("background-color", "#000")
                        div.html(this.$t(this.legends[i]) + ': ' + this.getLegendValues(i))
                            .style('left', this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                            .style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mousemove', (d) => {
                        div.style(
                            'left',
                            this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                        ).style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mouseout', (d) => {
                        div.transition().duration(500).style('opacity', 0);
                    });

                var lineData = [
                    [config.pointerWidth / 2, 0],
                    [0, -pointerHeadLength],
                    [-(config.pointerWidth / 2), 0],
                    [0, config.pointerTailLength],
                    [config.pointerWidth / 2, 0],
                ];
                var pointerLine = this.$d3.line().curve(this.$d3.curveLinear);
                var pg = svg
                    .append('g')
                    .data([lineData])
                    .attr('class', 'pointer')
                    .style('fill', colors[3])
                    .attr('transform', centerTx);

                pointer = pg
                    .append('path')
                    .attr('d', pointerLine /*function(d) { return pointerLine(d) +'Z';}*/)
                    .attr('transform', 'rotate(' + config.minAngle + ')')
                    .on('mouseover', (d, i) => {
                        div.transition().duration(200).style('opacity', 0.9).style('color', '#FFF');
                        //   .style("background-color", "#000")
                        div.html(this.datacontent.partial)
                            .style('left', this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                            .style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mousemove', (d) => {
                        div.style(
                            'left',
                            this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                        ).style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mouseout', (d) => {
                        div.transition().duration(500).style('opacity', 0);
                    });

                update(newValue === undefined ? 0 : newValue);
            };
            that.render = render;
            let update = (newValue, newConfiguration) => {
                if (newConfiguration !== undefined) {
                    configure(newConfiguration);
                }

                let needleValue = newValue;

                if (newValue > this.datacontent.total) {
                    needleValue = this.datacontent.total;
                } else if (newValue < 0) {
                    needleValue = 0;
                }

                var ratio = scale(needleValue);
                var newAngle = config.minAngle + ratio * range;

                pointer
                    .attr('transform', 'rotate(' + newAngle + ')');
            };
            that.update = update;

            configure(configuration);

            return that;
        },
        redrawChart() {
            this.$d3.select(this.$refs.svgcontent).selectAll('g').remove();
            this.mountChart();
        },
    },
};
</script>
